
const formatName = (name) => {
    /*
        parameters:
            name: str, expects only one word in string, first name or last name only

        returs:
            str: Name
    */

    if (name === undefined){
      return '';
    }
    let lowerCase = name.toLowerCase();
    let brokenName = lowerCase.split("");
    let firstLetter = brokenName[0].toUpperCase();
    brokenName[0] = firstLetter;
    return brokenName.join("");
  }

  export default formatName;